import React from "react";
import { Briefcase, MapPin } from "lucide-react";
import { experience } from "../data/mock";

const Experience = () => {
  return (
    <section id="experience" className="relative py-24 sm:py-32">
      {/* Top divider */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-zinc-800 to-transparent" />

      <div className="max-w-6xl mx-auto px-6">
        {/* Section header */}
        <div className="mb-16">
          <p className="text-blue-400 text-sm font-medium font-mono tracking-wide mb-3">
            04 — Experience
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-white tracking-tight mb-4">
            Work Experience
          </h2>
          <p className="text-zinc-500 text-base max-w-lg">
            A progressive career in IT systems administration, network engineering, and cloud infrastructure.
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-gradient-to-b from-blue-500/30 via-zinc-800 to-transparent hidden sm:block" />

          <div className="space-y-8 sm:space-y-12">
            {experience.map((job, index) => (
              <div
                key={job.id}
                className="group relative sm:pl-14"
              >
                {/* Timeline dot */}
                <div className="absolute left-[12px] top-1.5 hidden sm:flex items-center justify-center">
                  <div className="w-[15px] h-[15px] rounded-full border-2 border-zinc-700 bg-[#09090b] group-hover:border-blue-500 transition-colors duration-300 flex items-center justify-center">
                    <div className={`w-[5px] h-[5px] rounded-full ${index === 0 ? 'bg-blue-400' : 'bg-zinc-700 group-hover:bg-blue-400'} transition-colors duration-300`} />
                  </div>
                </div>

                {/* Card */}
                <div className="p-6 sm:p-8 rounded-xl bg-white/[0.02] border border-white/5 hover:border-blue-500/15 transition-all duration-300 hover:bg-blue-500/[0.02]">
                  {/* Header */}
                  <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 mb-5">
                    <div>
                      <h3 className="text-lg font-semibold text-white mb-1">
                        {job.role}
                      </h3>
                      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                        <div className="flex items-center gap-1.5">
                          <Briefcase size={13} className="text-blue-400" />
                          <span className="text-sm font-medium text-zinc-400">
                            {job.company}
                          </span>
                        </div>
                        <div className="flex items-center gap-1.5">
                          <MapPin size={13} className="text-zinc-600" />
                          <span className="text-sm text-zinc-500">
                            {job.location}
                          </span>
                        </div>
                      </div>
                    </div>
                    <span className="text-xs font-mono text-zinc-600 whitespace-nowrap">
                      {job.period}
                    </span>
                  </div>

                  {/* Highlights */}
                  <ul className="space-y-2.5">
                    {job.highlights.map((highlight, i) => (
                      <li
                        key={`${job.id}-h-${i}`}
                        className="flex items-start gap-3 text-sm text-zinc-400 leading-relaxed"
                      >
                        <span className="flex-shrink-0 w-1 h-1 rounded-full bg-blue-400/60 mt-2" />
                        {highlight}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
